module.exports = __webpack_public_path__ + "d081c93b70ec13307c45c6f353af045b.svg";